import { MapPin } from "lucide-react";
import Seo from "../components/Seo";
import MessageForm from "../components/MessageForm";
import { useSiteConfig } from "../lib/site";

export default function Contact() {
  const config = useSiteConfig();
  const b = config.business;

  return (
    <>
      <Seo
        title="Contact | Dorothy Read Healing, East Stroudsburg"
        description="Send Dorothy Read a message to arrange a visit at Wellspring Holistic Center, 239 E Brown St, Suite 1, East Stroudsburg, PA."
        path="/contact"
      />

      <section className="mx-auto max-w-6xl px-6 pb-16 pt-12 md:pt-20">
        <div className="max-w-3xl">
          <p className="eyebrow">Contact</p>
          <h1 className="mt-4 font-serif text-5xl font-semibold leading-[1.05] tracking-tight text-primary">
            Contact Dorothy
          </h1>
          <p className="mt-6 text-lg leading-relaxed text-foreground/90">
            Questions, or ready to book? Send a message below - Dorothy reads every one personally
            and replies in her own time.
          </p>
        </div>

        <div className="mt-12 grid gap-10 lg:grid-cols-2">
          <div className="card-soft p-6 md:p-8" data-testid="contact-form-panel">
            <MessageForm />
          </div>

          <div className="space-y-6">
            <div className="card-soft p-6" data-testid="contact-location-card">
              <h2 className="font-serif text-2xl font-semibold text-primary">Where to find Dorothy</h2>
              <a
                href={b.maps_url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-directions-link"
                className="mt-4 block text-lg leading-relaxed text-foreground underline-offset-4 transition-colors duration-200 hover:text-accent hover:underline"
              >
                <MapPin size={18} className="mr-2 inline text-accent" aria-hidden />
                <span className="font-semibold">{b.name}</span>
                <br />
                {b.address_lines.join(", ")}
              </a>
            </div>

            <div className="rounded-2xl border border-border bg-card p-6" data-testid="contact-policy-card">
              <h2 className="font-serif text-2xl font-semibold text-primary">Good to know</h2>
              <ul className="mt-4 space-y-3 text-base leading-relaxed text-foreground/90">
                <li>{config.policies.cancellation}</li>
                <li>{config.policies.payment}</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
